// La marca de las tres olas — estática (saludos) o viva (hero), con deriva suave.
import React, { useEffect, useRef } from 'react';
import { Animated, Easing, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

export function WavesMark({ width = 26 }: { width?: number }) {
  const h = Math.round(width * 0.42);
  return (
    <Svg width={width} height={h} viewBox="0 0 96 40" fill="none">
      <Path d="M2 10 Q14 2 26 10 T50 10 T74 10 T96 10" stroke="#8FF2E7" strokeWidth={7} strokeLinecap="round" />
      <Path d="M2 22 Q14 14 26 22 T50 22 T74 22 T96 22" stroke="#1ED3C7" strokeWidth={7} strokeLinecap="round" />
      <Path d="M2 34 Q14 26 26 34 T50 34 T74 34 T96 34" stroke="#10B3A9" strokeWidth={7} strokeLinecap="round" />
    </Svg>
  );
}

// Olas del hero: 3 capas SVG anchas desplazándose en bucle a velocidades distintas.
export function LiveWaves({ height = 88 }: { height?: number }) {
  const x1 = useRef(new Animated.Value(0)).current;
  const x2 = useRef(new Animated.Value(0)).current;
  const x3 = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const loop = (v: Animated.Value, ms: number) =>
      Animated.loop(
        Animated.sequence([
          Animated.timing(v, { toValue: -196, duration: ms, easing: Easing.linear, useNativeDriver: true }),
          Animated.timing(v, { toValue: 0, duration: 0, useNativeDriver: true }),
        ])
      ).start();
    loop(x1, 9000);
    loop(x2, 14000);
    loop(x3, 22000);
  }, [x1, x2, x3]);

  const layer = (v: Animated.Value, color: string, dy: number, amp: number) => (
    <Animated.View style={{ position: 'absolute', left: 0, top: dy, transform: [{ translateX: v }] }}>
      <Svg width={196 * 4} height={height} viewBox={`0 0 784 ${height}`} fill="none">
        <Path
          d={`M0 ${height / 2} ${Array.from({ length: 8 }, (_, i) => `Q${i * 98 + 24} ${height / 2 - amp} ${i * 98 + 49} ${height / 2} T${i * 98 + 98} ${height / 2}`).join(' ')}`}
          stroke={color}
          strokeWidth={3}
          strokeLinecap="round"
        />
      </Svg>
    </Animated.View>
  );

  return (
    <View style={{ height, overflow: 'hidden' }}>
      {layer(x3, 'rgba(16,179,169,0.40)', 14, 15)}
      {layer(x2, 'rgba(30,211,199,0.65)', 6, 12)}
      {layer(x1, 'rgba(143,242,231,0.85)', -4, 9)}
    </View>
  );
}
